var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerBenefits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1079,
    height: 194,
    viewBox: "0 0 1079 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1064_21028)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 1079,
    height: 194,
    fill: "url(#paint0_linear_1064_21028)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.4079 33.8998L66.304 33.9238C65.783 33.9244 65.2714 34.0609 64.8206 34.3195C64.3698 34.5781 63.9958 34.9497 63.7361 35.3969L57.2053 46.6448C56.9458 47.0917 56.8096 47.5984 56.8105 48.1139C56.8115 48.6294 56.9494 49.1356 57.2105 49.5816L63.7836 60.8055C64.0449 61.2518 64.4203 61.622 64.872 61.8789C65.3237 62.1359 65.8358 62.2705 66.3568 62.2692L79.4607 62.2452C79.9816 62.2446 80.4933 62.1081 80.9441 61.8495C81.3949 61.5909 81.7689 61.2193 82.0286 60.7722L88.5594 49.5242C88.8189 49.0773 88.9551 48.5706 88.9542 48.0551C88.9532 47.5396 88.8153 47.0334 88.5541 46.5875L81.9791 35.3596C81.7175 34.9143 81.3422 34.5451 80.8909 34.2889C80.4396 34.0327 79.9281 33.8985 79.4079 33.8998V33.8998Z",
    stroke: "#F0B744",
    strokeWidth: 1.11973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7692 49.6698L38.6693 49.6938C38.1483 49.6944 37.6367 49.8309 37.1859 50.0895C36.7351 50.3481 36.361 50.7197 36.1014 51.1669L29.5686 62.4148C29.309 62.8618 29.1729 63.3684 29.1738 63.8839C29.1747 64.3994 29.3127 64.9056 29.5738 65.3516L36.1469 76.5756C36.4082 77.0218 36.7836 77.392 37.2353 77.649C37.687 77.9059 38.1991 78.0405 38.7201 78.0392L51.824 78.0152C52.3449 78.0146 52.8565 77.8781 53.3073 77.6196C53.7581 77.361 54.1322 76.9894 54.3919 76.5422L60.9247 65.2942C61.1842 64.8473 61.3203 64.3406 61.3194 63.8251C61.3185 63.3096 61.1805 62.8034 60.9194 62.3575L54.3463 51.1335C54.0847 50.6867 53.7087 50.3161 53.2562 50.0591C52.8038 49.8021 52.2908 49.6679 51.7692 49.6698Z",
    stroke: "#F0B744",
    strokeWidth: 1.11973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7125 18.2309L38.6126 18.2548C38.0916 18.2555 37.58 18.3919 37.1292 18.6505C36.6784 18.9091 36.3044 19.2807 36.0447 19.7279L29.5139 30.9759C29.2543 31.4228 29.1182 31.9295 29.1191 32.445C29.1201 32.9605 29.258 33.4666 29.5191 33.9126L36.0902 45.1366C36.3515 45.5828 36.7269 45.953 37.1786 46.21C37.6303 46.4669 38.1424 46.6015 38.6634 46.6003L51.7673 46.5763C52.2883 46.5757 52.7999 46.4392 53.2507 46.1806C53.7015 45.922 54.0755 45.5504 54.3352 45.1032L60.868 33.8552C61.1275 33.4083 61.2637 32.9017 61.2627 32.3862C61.2618 31.8706 61.1239 31.3645 60.8627 30.9185L54.2897 19.6945C54.0281 19.2477 53.652 18.8771 53.1996 18.6202C52.7471 18.3632 52.2342 18.2289 51.7125 18.2309V18.2309Z",
    stroke: "#F0B744",
    strokeWidth: 1.11973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6794 34.0004L11.5755 34.0244C11.0545 34.025 10.5429 34.1615 10.0921 34.4201C9.64132 34.6787 9.26726 35.0503 9.00758 35.4975L2.47676 46.7454C2.21724 47.1923 2.0811 47.699 2.08202 48.2145C2.08295 48.73 2.2209 49.2362 2.48203 49.6821L9.05509 60.9061C9.31638 61.3524 9.69177 61.7226 10.1435 61.9795C10.5952 62.2365 11.1073 62.3711 11.6283 62.3698L24.7302 62.3458C25.2512 62.3452 25.7628 62.2087 26.2136 61.9501C26.6644 61.6915 27.0384 61.3199 27.2981 60.8727L33.8289 49.6248C34.0884 49.1779 34.2246 48.6712 34.2237 48.1557C34.2227 47.6402 34.0848 47.134 33.8237 46.6881L27.2506 35.4602C26.989 35.0149 26.6137 34.6457 26.1624 34.3895C25.7111 34.1332 25.1996 33.9991 24.6794 34.0004Z",
    stroke: "#F0B744",
    strokeWidth: 1.11973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3513 2.46134L66.2474 2.48532C65.7264 2.48594 65.2148 2.62241 64.764 2.88101C64.3132 3.1396 63.9391 3.5112 63.6795 3.95839L57.1486 15.2063C56.8891 15.6533 56.753 16.1599 56.7539 16.6754C56.7548 17.1909 56.8928 17.6971 57.1539 18.1431L63.725 29.3671C63.9863 29.8133 64.3617 30.1835 64.8134 30.4405C65.2651 30.6974 65.7772 30.832 66.2982 30.8307L79.4021 30.8068C79.923 30.8061 80.4346 30.6697 80.8854 30.4111C81.3362 30.1525 81.7103 29.7809 81.97 29.3337L88.5008 18.0857C88.7603 17.6388 88.8965 17.1321 88.8955 16.6166C88.8946 16.1011 88.7567 15.5949 88.4955 15.149L81.9244 3.92501C81.6632 3.47877 81.2878 3.10855 80.8361 2.8516C80.3843 2.59466 79.8722 2.46006 79.3513 2.46134Z",
    stroke: "#F0B744",
    strokeWidth: 1.11973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M82.109 69.665L69.0052 69.6889C68.4842 69.6896 67.9726 69.826 67.5218 70.0846C67.071 70.3432 66.6969 70.7148 66.4372 71.162L59.9084 82.41C59.6489 82.8569 59.5127 83.3635 59.5137 83.8791C59.5146 84.3946 59.6525 84.9007 59.9137 85.3467L66.4848 96.5707C66.746 97.0169 67.1214 97.3871 67.5731 97.6441C68.0249 97.901 68.537 98.0356 69.0579 98.0343L82.1618 98.0104C82.6828 98.0097 83.1944 97.8733 83.6452 97.6147C84.096 97.3561 84.4701 96.9845 84.7297 96.5373L91.2606 85.2893C91.5201 84.8424 91.6562 84.3357 91.6553 83.8202C91.6544 83.3047 91.5164 82.7986 91.2553 82.3526L84.6842 71.1286C84.4228 70.6821 84.0471 70.3117 83.595 70.0547C83.1429 69.7978 82.6303 69.6633 82.109 69.665Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M82.0544 38.2265L68.9505 38.2505C68.4295 38.2511 67.9179 38.3876 67.4671 38.6461C67.0163 38.9047 66.6423 39.2763 66.3826 39.7235L59.8518 50.9715C59.5922 51.4184 59.4561 51.9251 59.457 52.4406C59.4579 52.9561 59.5959 53.4623 59.857 53.9082L66.4281 65.1322C66.6894 65.5784 67.0648 65.9487 67.5165 66.2056C67.9682 66.4625 68.4803 66.5971 69.0013 66.5959L82.1052 66.5719C82.6262 66.5713 83.1378 66.4348 83.5886 66.1762C84.0394 65.9176 84.4134 65.546 84.6731 65.0988L91.2039 53.8509C91.4634 53.4039 91.5996 52.8973 91.5987 52.3818C91.5977 51.8663 91.4598 51.3601 91.1987 50.9141L84.6276 39.6901C84.3663 39.2439 83.9909 38.8737 83.5392 38.6167C83.0875 38.3598 82.5754 38.2252 82.0544 38.2265Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M54.4157 53.9965L41.3138 54.0205C40.7928 54.0211 40.2812 54.1576 39.8304 54.4162C39.3796 54.6748 39.0055 55.0464 38.7459 55.4935L32.215 66.7415C31.9555 67.1884 31.8194 67.6951 31.8203 68.2106C31.8212 68.7261 31.9592 69.2323 32.2203 69.6782L38.7914 80.9022C39.0527 81.3485 39.4281 81.7187 39.8798 81.9756C40.3315 82.2326 40.8436 82.3672 41.3646 82.3659L54.4665 82.3419C54.9875 82.3413 55.4991 82.2048 55.9499 81.9462C56.4007 81.6876 56.7747 81.316 57.0344 80.8688L63.5672 69.6209C63.8267 69.174 63.9629 68.6673 63.9619 68.1518C63.961 67.6363 63.8231 67.1301 63.5619 66.6841L56.9889 55.4602C56.7276 55.0139 56.3522 54.6437 55.9005 54.3868C55.4488 54.1298 54.9367 53.9952 54.4157 53.9965Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M54.359 22.5575L41.2571 22.5815C40.7362 22.5821 40.2245 22.7186 39.7738 22.9772C39.323 23.2358 38.9489 23.6074 38.6892 24.0546L32.1584 35.3025C31.8989 35.7494 31.7627 36.2561 31.7637 36.7716C31.7646 37.2871 31.9025 37.7933 32.1637 38.2393L38.7348 49.4633C38.996 49.9095 39.3714 50.2797 39.8231 50.5367C40.2749 50.7936 40.787 50.9282 41.3079 50.9269L54.4098 50.9029C54.9308 50.9023 55.4424 50.7658 55.8932 50.5073C56.344 50.2487 56.7181 49.8771 56.9778 49.4299L63.5106 38.1819C63.7701 37.735 63.9062 37.2283 63.9053 36.7128C63.9044 36.1973 63.7664 35.6911 63.5053 35.2452L56.9322 24.0212C56.6709 23.575 56.2956 23.2047 55.8438 22.9478C55.3921 22.6909 54.88 22.5563 54.359 22.5575Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M27.3825 69.7651L14.2786 69.789C13.7576 69.7897 13.246 69.9261 12.7952 70.1847C12.3444 70.4433 11.9704 70.8149 11.7107 71.2621L5.18184 82.5101C4.92232 82.957 4.78618 83.4636 4.7871 83.9791C4.78802 84.4947 4.92598 85.0008 5.1871 85.4468L11.7582 96.6708C12.0195 97.117 12.3949 97.4872 12.8466 97.7442C13.2983 98.0011 13.8104 98.1357 14.3314 98.1344L27.4353 98.1105C27.9562 98.1098 28.4679 97.9734 28.9186 97.7148C29.3694 97.4562 29.7435 97.0846 30.0032 96.6374L36.536 85.3894C36.7955 84.9425 36.9316 84.4358 36.9307 83.9203C36.9298 83.4048 36.7918 82.8987 36.5307 82.4527L29.9576 71.2287C29.6962 70.7822 29.3205 70.4118 28.8684 70.1548C28.4163 69.8979 27.9038 69.7634 27.3825 69.7651Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M27.3258 38.3261L14.222 38.3501C13.701 38.3507 13.1894 38.4872 12.7386 38.7458C12.2878 39.0044 11.9137 39.3759 11.654 39.8231L5.1252 51.0711C4.86568 51.518 4.72954 52.0247 4.73046 52.5402C4.73138 53.0557 4.86934 53.5619 5.13046 54.0078L11.7016 65.2318C11.9628 65.678 12.3382 66.0483 12.7899 66.3052C13.2417 66.5622 13.7538 66.6968 14.2747 66.6955L27.3786 66.6715C27.8996 66.6709 28.4112 66.5344 28.862 66.2758C29.3128 66.0172 29.6869 65.6456 29.9465 65.1984L36.4793 53.9505C36.7389 53.5036 36.875 52.9969 36.8741 52.4814C36.8731 51.9659 36.7352 51.4597 36.4741 51.0137L29.901 39.7898C29.6396 39.3432 29.2639 38.9728 28.8118 38.7159C28.3597 38.4589 27.8471 38.3245 27.3258 38.3261Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M108.97 22.4574L95.8665 22.4814C95.3455 22.482 94.8339 22.6185 94.3831 22.8771C93.9323 23.1357 93.5583 23.5073 93.2986 23.9545L86.7678 35.2024C86.5083 35.6493 86.3721 36.156 86.373 36.6715C86.374 37.187 86.5119 37.6932 86.773 38.1392L93.3441 49.3632C93.6054 49.8094 93.9808 50.1796 94.4325 50.4366C94.8842 50.6935 95.3963 50.8281 95.9173 50.8268L109.021 50.8028C109.542 50.8022 110.054 50.6657 110.505 50.4072C110.955 50.1486 111.329 49.777 111.589 49.3298L118.12 38.0818C118.379 37.6349 118.516 37.1282 118.515 36.6127C118.514 36.0972 118.376 35.591 118.115 35.1451L111.544 23.9211C111.282 23.4749 110.907 23.1046 110.455 22.8477C110.003 22.5908 109.491 22.4562 108.97 22.4574Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M81.9977 6.78751L68.8939 6.81149C68.3729 6.81211 67.8613 6.94858 67.4105 7.20718C66.9597 7.46577 66.5856 7.83737 66.3259 8.28456L59.7951 19.5325C59.5356 19.9794 59.3995 20.4861 59.4004 21.0016C59.4013 21.5171 59.5393 22.0233 59.8004 22.4693L66.3715 33.6932C66.6328 34.1395 67.0082 34.5097 67.4599 34.7666C67.9116 35.0236 68.4237 35.1582 68.9447 35.1569L82.0485 35.1329C82.5695 35.1323 83.0811 34.9958 83.5319 34.7372C83.9827 34.4786 84.3568 34.107 84.6165 33.6599L91.1473 22.4119C91.4068 21.965 91.5429 21.4583 91.542 20.9428C91.5411 20.4273 91.4031 19.9211 91.142 19.4752L84.5709 8.25118C84.3096 7.80494 83.9343 7.43472 83.4825 7.17777C83.0308 6.92083 82.5187 6.78623 81.9977 6.78751Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.621 18.1288L94.5189 18.1528C93.9979 18.1534 93.4863 18.2899 93.0355 18.5485C92.5847 18.8071 92.2106 19.1787 91.9509 19.6259L85.4201 30.8738C85.1606 31.3207 85.0245 31.8274 85.0254 32.3429C85.0263 32.8584 85.1643 33.3646 85.4254 33.8106L91.9965 45.0345C92.2578 45.4808 92.6332 45.851 93.0849 46.1079C93.5366 46.3649 94.0487 46.4995 94.5697 46.4982L107.672 46.4742C108.193 46.4736 108.704 46.3371 109.155 46.0785C109.606 45.8199 109.98 45.4484 110.239 45.0012L116.77 33.7532C117.03 33.3063 117.166 32.7996 117.165 32.2841C117.164 31.7686 117.026 31.2624 116.765 30.8165L110.194 19.5925C109.933 19.1463 109.557 18.776 109.106 18.5191C108.654 18.2621 108.142 18.1275 107.621 18.1288Z",
    stroke: "#F0B744",
    strokeWidth: 0.559865,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4626 65.3661L66.3587 65.3901C65.8377 65.3907 65.3261 65.5272 64.8753 65.7858C64.4245 66.0444 64.0505 66.416 63.7908 66.8632L57.26 78.1111C57.0004 78.558 56.8643 79.0647 56.8652 79.5802C56.8661 80.0957 57.0041 80.6019 57.2652 81.0479L63.8383 92.2718C64.0996 92.7181 64.475 93.0883 64.9267 93.3452C65.3784 93.6022 65.8905 93.7368 66.4115 93.7355L79.5154 93.7115C80.0363 93.7109 80.548 93.5744 80.9987 93.3158C81.4495 93.0572 81.8236 92.6857 82.0833 92.2385L88.6141 80.9905C88.8736 80.5436 89.0098 80.0369 89.0088 79.5214C89.0079 79.0059 88.87 78.4997 88.6088 78.0538L82.0377 66.8298C81.7763 66.3833 81.4006 66.0129 80.9485 65.7559C80.4964 65.4989 79.9839 65.3645 79.4626 65.3661Z",
    stroke: "#F0B744",
    strokeWidth: 0.279933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.736 65.4662L11.6321 65.4902C11.1112 65.4908 10.5995 65.6273 10.1488 65.8859C9.69796 66.1445 9.3239 66.5161 9.06422 66.9633L2.5334 78.2112C2.27388 78.6581 2.13774 79.1648 2.13866 79.6803C2.13959 80.1958 2.27754 80.702 2.53867 81.148L9.11173 92.3719C9.37302 92.8182 9.74841 93.1884 10.2001 93.4453C10.6518 93.7023 11.1639 93.8369 11.6849 93.8356L24.7868 93.8116C25.3078 93.811 25.8194 93.6745 26.2702 93.4159C26.721 93.1573 27.0951 92.7858 27.3547 92.3386L33.8856 81.0906C34.1451 80.6437 34.2812 80.137 34.2803 79.6215C34.2794 79.106 34.1414 78.5998 33.8803 78.1539L27.3092 66.9299C27.0479 66.4837 26.6725 66.1134 26.2208 65.8565C25.7691 65.5995 25.257 65.4649 24.736 65.4662Z",
    stroke: "#F0B744",
    strokeWidth: 0.279933,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1039.41 129.511L1026.3 129.535C1025.78 129.535 1025.27 129.672 1024.82 129.93C1024.37 130.189 1024 130.561 1023.74 131.008L1017.21 142.256C1016.95 142.703 1016.81 143.209 1016.81 143.725C1016.81 144.24 1016.95 144.746 1017.21 145.192L1023.78 156.416C1024.04 156.863 1024.42 157.233 1024.87 157.49C1025.32 157.747 1025.84 157.881 1026.36 157.88L1039.46 157.856C1039.98 157.855 1040.49 157.719 1040.94 157.46C1041.39 157.202 1041.77 156.83 1042.03 156.383L1048.56 145.135C1048.82 144.688 1048.96 144.181 1048.95 143.666C1048.95 143.15 1048.82 142.644 1048.55 142.198L1041.98 130.97C1041.72 130.525 1041.34 130.156 1040.89 129.9C1040.44 129.643 1039.93 129.509 1039.41 129.511V129.511Z",
    stroke: "#F0B744",
    strokeWidth: 1.11973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.77 145.281L998.669 145.305C998.148 145.305 997.637 145.442 997.186 145.7C996.735 145.959 996.361 146.331 996.101 146.778L989.569 158.026C989.309 158.473 989.173 158.979 989.174 159.495C989.175 160.01 989.313 160.516 989.574 160.962L996.147 172.186C996.408 172.633 996.784 173.003 997.235 173.26C997.687 173.517 998.199 173.651 998.72 173.65L1011.82 173.626C1012.34 173.625 1012.86 173.489 1013.31 173.23C1013.76 172.972 1014.13 172.6 1014.39 172.153L1020.92 160.905C1021.18 160.458 1021.32 159.951 1021.32 159.436C1021.32 158.92 1021.18 158.414 1020.92 157.968L1014.35 146.744C1014.08 146.298 1013.71 145.927 1013.26 145.67C1012.8 145.413 1012.29 145.279 1011.77 145.281Z",
    stroke: "#F0B744",
    strokeWidth: 1.11973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.71 113.842L998.613 113.866C998.092 113.866 997.58 114.003 997.129 114.261C996.678 114.52 996.304 114.892 996.045 115.339L989.514 126.587C989.254 127.034 989.118 127.54 989.119 128.056C989.12 128.571 989.258 129.077 989.519 129.523L996.09 140.747C996.352 141.194 996.727 141.564 997.179 141.821C997.63 142.078 998.142 142.212 998.663 142.211L1011.77 142.187C1012.29 142.186 1012.8 142.05 1013.25 141.791C1013.7 141.533 1014.08 141.161 1014.34 140.714L1020.87 129.466C1021.13 129.019 1021.26 128.512 1021.26 127.997C1021.26 127.481 1021.12 126.975 1020.86 126.529L1014.29 115.305C1014.03 114.859 1013.65 114.488 1013.2 114.231C1012.75 113.974 1012.23 113.84 1011.71 113.842V113.842Z",
    stroke: "#F0B744",
    strokeWidth: 1.11973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.679 129.611L971.575 129.635C971.055 129.636 970.543 129.772 970.092 130.031C969.641 130.29 969.267 130.661 969.008 131.108L962.477 142.356C962.217 142.803 962.081 143.31 962.082 143.825C962.083 144.341 962.221 144.847 962.482 145.293L969.055 156.517C969.316 156.963 969.692 157.333 970.143 157.59C970.595 157.847 971.107 157.982 971.628 157.981L984.73 157.957C985.251 157.956 985.763 157.82 986.214 157.561C986.664 157.302 987.038 156.931 987.298 156.484L993.829 145.236C994.088 144.789 994.225 144.282 994.224 143.767C994.223 143.251 994.085 142.745 993.824 142.299L987.251 131.071C986.989 130.626 986.614 130.257 986.162 130C985.711 129.744 985.2 129.61 984.679 129.611Z",
    stroke: "#F0B744",
    strokeWidth: 1.11973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.35 98.0722L1026.25 98.0962C1025.73 98.0968 1025.21 98.2333 1024.76 98.4918C1024.31 98.7504 1023.94 99.122 1023.68 99.5692L1017.15 110.817C1016.89 111.264 1016.75 111.771 1016.75 112.286C1016.75 112.802 1016.89 113.308 1017.15 113.754L1023.72 124.978C1023.99 125.424 1024.36 125.794 1024.81 126.051C1025.27 126.308 1025.78 126.443 1026.3 126.442L1039.4 126.418C1039.92 126.417 1040.43 126.28 1040.89 126.022C1041.34 125.763 1041.71 125.392 1041.97 124.945L1048.5 113.697C1048.76 113.25 1048.9 112.743 1048.9 112.227C1048.89 111.712 1048.76 111.206 1048.5 110.76L1041.92 99.5358C1041.66 99.0896 1041.29 98.7194 1040.84 98.4624C1040.38 98.2055 1039.87 98.0709 1039.35 98.0722Z",
    stroke: "#F0B744",
    strokeWidth: 1.11973,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1042.11 165.276L1029.01 165.3C1028.48 165.3 1027.97 165.437 1027.52 165.695C1027.07 165.954 1026.7 166.326 1026.44 166.773L1019.91 178.021C1019.65 178.468 1019.51 178.974 1019.51 179.49C1019.51 180.005 1019.65 180.512 1019.91 180.958L1026.48 192.182C1026.75 192.628 1027.12 192.998 1027.57 193.255C1028.02 193.512 1028.54 193.646 1029.06 193.645L1042.16 193.621C1042.68 193.621 1043.19 193.484 1043.65 193.226C1044.1 192.967 1044.47 192.595 1044.73 192.148L1051.26 180.9C1051.52 180.453 1051.66 179.947 1051.66 179.431C1051.65 178.916 1051.52 178.409 1051.26 177.963L1044.68 166.739C1044.42 166.293 1044.05 165.923 1043.59 165.666C1043.14 165.409 1042.63 165.274 1042.11 165.276Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1042.05 133.837L1028.95 133.861C1028.43 133.862 1027.92 133.998 1027.47 134.257C1027.02 134.516 1026.64 134.887 1026.38 135.334L1019.85 146.582C1019.59 147.029 1019.46 147.536 1019.46 148.051C1019.46 148.567 1019.6 149.073 1019.86 149.519L1026.43 160.743C1026.69 161.189 1027.06 161.559 1027.52 161.816C1027.97 162.073 1028.48 162.208 1029 162.207L1042.11 162.183C1042.63 162.182 1043.14 162.046 1043.59 161.787C1044.04 161.528 1044.41 161.157 1044.67 160.71L1051.2 149.462C1051.46 149.015 1051.6 148.508 1051.6 147.993C1051.6 147.477 1051.46 146.971 1051.2 146.525L1044.63 135.301C1044.37 134.855 1043.99 134.485 1043.54 134.228C1043.09 133.971 1042.58 133.836 1042.05 133.837Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1014.42 149.607L1001.31 149.631C1000.79 149.632 1000.28 149.768 999.83 150.027C999.38 150.286 999.006 150.657 998.746 151.104L992.215 162.352C991.956 162.799 991.819 163.306 991.82 163.821C991.821 164.337 991.959 164.843 992.22 165.289L998.791 176.513C999.053 176.959 999.428 177.33 999.88 177.586C1000.33 177.843 1000.84 177.978 1001.36 177.977L1014.47 177.953C1014.99 177.952 1015.5 177.816 1015.95 177.557C1016.4 177.298 1016.77 176.927 1017.03 176.48L1023.57 165.232C1023.83 164.785 1023.96 164.278 1023.96 163.763C1023.96 163.247 1023.82 162.741 1023.56 162.295L1016.99 151.071C1016.73 150.625 1016.35 150.255 1015.9 149.998C1015.45 149.741 1014.94 149.606 1014.42 149.607Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1014.36 118.168L1001.26 118.192C1000.74 118.193 1000.22 118.329 999.774 118.588C999.323 118.847 998.949 119.218 998.689 119.665L992.158 130.913C991.899 131.36 991.763 131.867 991.764 132.382C991.765 132.898 991.903 133.404 992.164 133.85L998.735 145.074C998.996 145.52 999.371 145.891 999.823 146.147C1000.27 146.404 1000.79 146.539 1001.31 146.538L1014.41 146.514C1014.93 146.513 1015.44 146.377 1015.89 146.118C1016.34 145.859 1016.72 145.488 1016.98 145.041L1023.51 133.793C1023.77 133.346 1023.91 132.839 1023.91 132.324C1023.9 131.808 1023.77 131.302 1023.51 130.856L1016.93 119.632C1016.67 119.186 1016.3 118.816 1015.84 118.559C1015.39 118.302 1014.88 118.167 1014.36 118.168Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M987.382 165.376L974.279 165.4C973.758 165.4 973.246 165.537 972.795 165.796C972.344 166.054 971.97 166.426 971.711 166.873L965.182 178.121C964.922 178.568 964.786 179.074 964.787 179.59C964.788 180.105 964.926 180.612 965.187 181.058L971.758 192.282C972.019 192.728 972.395 193.098 972.847 193.355C973.298 193.612 973.81 193.747 974.331 193.745L987.435 193.721C987.956 193.721 988.468 193.584 988.919 193.326C989.369 193.067 989.743 192.695 990.003 192.248L996.536 181C996.795 180.553 996.932 180.047 996.931 179.531C996.93 179.016 996.792 178.509 996.531 178.064L989.958 166.84C989.696 166.393 989.32 166.023 988.868 165.766C988.416 165.509 987.904 165.374 987.382 165.376Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M987.326 133.937L974.222 133.961C973.701 133.962 973.189 134.098 972.739 134.357C972.288 134.615 971.914 134.987 971.654 135.434L965.125 146.682C964.866 147.129 964.73 147.636 964.73 148.151C964.731 148.667 964.869 149.173 965.13 149.619L971.702 160.843C971.963 161.289 972.338 161.659 972.79 161.916C973.242 162.173 973.754 162.308 974.275 162.306L987.379 162.282C987.9 162.282 988.411 162.145 988.862 161.887C989.313 161.628 989.687 161.256 989.947 160.809L996.479 149.561C996.739 149.114 996.875 148.608 996.874 148.092C996.873 147.577 996.735 147.071 996.474 146.625L989.901 135.401C989.64 134.954 989.264 134.584 988.812 134.327C988.36 134.07 987.847 133.935 987.326 133.937Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1068.97 118.068L1055.87 118.092C1055.35 118.093 1054.83 118.229 1054.38 118.488C1053.93 118.747 1053.56 119.118 1053.3 119.565L1046.77 130.813C1046.51 131.26 1046.37 131.767 1046.37 132.282C1046.37 132.798 1046.51 133.304 1046.77 133.75L1053.34 144.974C1053.61 145.42 1053.98 145.79 1054.43 146.047C1054.88 146.304 1055.4 146.439 1055.92 146.438L1069.02 146.414C1069.54 146.413 1070.05 146.277 1070.5 146.018C1070.96 145.759 1071.33 145.388 1071.59 144.941L1078.12 133.693C1078.38 133.246 1078.52 132.739 1078.51 132.224C1078.51 131.708 1078.38 131.202 1078.11 130.756L1071.54 119.532C1071.28 119.086 1070.91 118.715 1070.46 118.459C1070 118.202 1069.49 118.067 1068.97 118.068Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M1042 102.398L1028.89 102.422C1028.37 102.423 1027.86 102.559 1027.41 102.818C1026.96 103.077 1026.59 103.448 1026.33 103.895L1019.8 115.143C1019.54 115.59 1019.4 116.097 1019.4 116.612C1019.4 117.128 1019.54 117.634 1019.8 118.08L1026.37 129.304C1026.63 129.75 1027.01 130.121 1027.46 130.377C1027.91 130.634 1028.42 130.769 1028.94 130.768L1042.05 130.744C1042.57 130.743 1043.08 130.607 1043.53 130.348C1043.98 130.089 1044.36 129.718 1044.62 129.271L1051.15 118.023C1051.41 117.576 1051.54 117.069 1051.54 116.554C1051.54 116.038 1051.4 115.532 1051.14 115.086L1044.57 103.862C1044.31 103.416 1043.93 103.046 1043.48 102.789C1043.03 102.532 1042.52 102.397 1042 102.398Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.62 113.74L1054.52 113.764C1054 113.764 1053.49 113.901 1053.04 114.159C1052.58 114.418 1052.21 114.79 1051.95 115.237L1045.42 126.485C1045.16 126.932 1045.02 127.438 1045.03 127.954C1045.03 128.469 1045.16 128.975 1045.43 129.421L1052 140.645C1052.26 141.092 1052.63 141.462 1053.08 141.719C1053.54 141.976 1054.05 142.11 1054.57 142.109L1067.67 142.085C1068.19 142.084 1068.7 141.948 1069.15 141.689C1069.61 141.431 1069.98 141.059 1070.24 140.612L1076.77 129.364C1077.03 128.917 1077.17 128.41 1077.17 127.895C1077.16 127.379 1077.03 126.873 1076.77 126.427L1070.19 115.203C1069.93 114.757 1069.56 114.387 1069.11 114.13C1068.65 113.873 1068.14 113.738 1067.62 113.74Z",
    stroke: "#F0B744",
    strokeWidth: 0.559865,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.46 160.977L1026.36 161.001C1025.84 161.002 1025.33 161.138 1024.88 161.397C1024.42 161.655 1024.05 162.027 1023.79 162.474L1017.26 173.722C1017 174.169 1016.86 174.676 1016.87 175.191C1016.87 175.707 1017 176.213 1017.27 176.659L1023.84 187.883C1024.1 188.329 1024.47 188.699 1024.93 188.956C1025.38 189.213 1025.89 189.348 1026.41 189.346L1039.52 189.322C1040.04 189.322 1040.55 189.185 1041 188.927C1041.45 188.668 1041.82 188.296 1042.08 187.849L1048.61 176.601C1048.87 176.154 1049.01 175.648 1049.01 175.132C1049.01 174.617 1048.87 174.111 1048.61 173.665L1042.04 162.441C1041.78 161.994 1041.4 161.624 1040.95 161.367C1040.5 161.11 1039.98 160.975 1039.46 160.977Z",
    stroke: "#F0B744",
    strokeWidth: 0.279933,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.736 161.077L971.632 161.101C971.111 161.102 970.6 161.238 970.149 161.497C969.698 161.755 969.324 162.127 969.064 162.574L962.533 173.822C962.274 174.269 962.138 174.776 962.139 175.291C962.14 175.807 962.278 176.313 962.539 176.759L969.112 187.983C969.373 188.429 969.748 188.799 970.2 189.056C970.652 189.313 971.164 189.448 971.685 189.446L984.787 189.422C985.308 189.422 985.819 189.285 986.27 189.027C986.721 188.768 987.095 188.397 987.355 187.949L993.886 176.701C994.145 176.255 994.281 175.748 994.28 175.232C994.279 174.717 994.141 174.211 993.88 173.765L987.309 162.541C987.048 162.094 986.673 161.724 986.221 161.467C985.769 161.21 985.257 161.076 984.736 161.077Z",
    stroke: "#F0B744",
    strokeWidth: 0.279933,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.086 112.458C418.406 106.349 422.801 100.832 428.907 100.129L665.879 72.8505C671.374 72.218 676.329 76.1653 676.941 81.6625C677.548 87.1131 673.655 92.0466 668.213 92.7237L645.099 95.5991C637.561 96.5369 632.17 103.369 633.01 110.918C633.613 116.326 638.484 120.212 643.89 119.597L649.617 118.946C656.035 118.217 661.818 122.83 662.532 129.249C663.247 135.669 658.624 141.464 652.206 142.194L422.304 168.329C416.158 169.028 410.621 164.61 409.937 158.463C409.252 152.315 413.68 146.765 419.826 146.067L449.97 142.64C456.099 141.943 460.514 136.409 459.831 130.279C459.148 124.149 453.627 119.744 447.498 120.441L431.389 122.272C425.275 122.967 419.767 118.573 419.086 112.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.469 134.596L480.024 139.581L465.176 141.269L462.775 119.712L477.315 118.059L477.851 122.872L468.639 123.92L469.037 127.495L476.977 126.593L477.475 131.062L469.535 131.965L469.948 135.678L479.469 134.596Z",
    fill: "#184A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.814 130.321L485.334 129.786C483.547 129.571 482.285 129.076 481.549 128.301C480.836 127.523 480.391 126.344 480.215 124.762C479.937 122.264 480.386 120.356 481.562 119.039C482.758 117.696 484.743 116.867 487.515 116.551C488.661 116.421 489.686 116.351 490.59 116.341C491.494 116.331 492.336 116.398 493.118 116.541L493.65 121.32C491.875 121.22 490.653 121.185 489.984 121.215C489.337 121.242 488.658 121.296 487.948 121.376C486.986 121.486 486.305 121.726 485.905 122.096C485.505 122.467 485.348 123.03 485.432 123.786C485.473 124.153 485.573 124.432 485.734 124.622C485.892 124.79 486.17 124.898 486.57 124.945L490.802 125.439C492.024 125.578 492.914 125.756 493.472 125.971C494.027 126.163 494.488 126.447 494.855 126.823C495.27 127.217 495.596 127.749 495.833 128.418C496.093 129.085 496.277 129.911 496.387 130.897C496.665 133.395 496.202 135.281 494.998 136.556C493.792 137.807 491.791 138.591 488.995 138.909C487.575 139.071 486.212 139.133 484.909 139.095C483.608 139.081 482.588 138.988 481.85 138.816L481.287 133.762C482.237 133.956 483.352 134.073 484.632 134.113C485.911 134.13 487.18 134.067 488.44 133.924C489.448 133.809 490.133 133.604 490.495 133.307C490.856 133.011 490.995 132.485 490.911 131.728C490.857 131.247 490.75 130.911 490.59 130.72C490.449 130.504 490.191 130.371 489.814 130.321Z",
    fill: "#184A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 130.728L504.674 136.779L499.346 137.384L496.946 115.828L504.817 114.933C508.14 114.555 510.565 114.871 512.093 115.881C513.618 116.868 514.533 118.726 514.837 121.453C515.138 124.158 514.616 126.248 513.272 127.724C511.949 129.174 509.74 130.075 506.647 130.427L504 130.728ZM509.44 122.067C509.328 121.058 508.974 120.379 508.378 120.029C507.782 119.679 506.774 119.585 505.353 119.746L502.809 120.035L503.479 126.052L506.023 125.763C507.467 125.599 508.425 125.246 508.899 124.705C509.395 124.161 509.575 123.281 509.44 122.067Z",
    fill: "#184A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.907 128.521L533.462 133.506L518.613 135.194L516.213 113.637L530.752 111.984L531.288 116.798L522.077 117.845L522.475 121.421L530.415 120.518L530.912 124.987L522.972 125.89L523.386 129.603L532.907 128.521Z",
    fill: "#184A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.497 127.551C545.414 127.447 546.4 127.242 547.457 126.936C548.511 126.608 549.444 126.235 550.256 125.817L550.781 130.528C549.576 131.175 548.48 131.648 547.493 131.946C546.507 132.267 545.465 132.49 544.365 132.615C542.371 132.841 540.753 132.793 539.511 132.47C538.268 132.147 537.235 131.522 536.413 130.594C535.72 129.791 535.149 128.73 534.701 127.412C534.275 126.091 533.955 124.467 533.741 122.542C533.312 118.691 533.825 115.79 535.278 113.837C536.752 111.86 539.299 110.665 542.919 110.253C543.973 110.133 544.915 110.049 545.745 110.002C546.575 109.954 547.329 109.949 548.006 109.988L548.523 114.63C547.762 114.67 546.967 114.725 546.14 114.796C545.335 114.864 544.44 114.954 543.455 115.066C542.195 115.21 541.269 115.443 540.679 115.765C540.109 116.062 539.708 116.525 539.476 117.155C539.252 117.645 539.125 118.274 539.095 119.044C539.064 119.813 539.113 120.771 539.241 121.917C539.361 122.994 539.507 123.894 539.68 124.617C539.874 125.315 540.112 125.891 540.395 126.347C540.759 126.909 541.242 127.283 541.843 127.47C542.444 127.657 543.329 127.684 544.497 127.551Z",
    fill: "#184A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.047 109.109L558.447 130.666L553.119 131.271L550.719 109.715L556.047 109.109Z",
    fill: "#184A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.596 129.853L559.993 130.49L565.567 108.027L571.101 107.398L581.269 128.071L575.701 128.704L574.165 125.223L566.328 126.114L565.596 129.853ZM568.803 113.021C568.691 113.683 568.562 114.394 568.414 115.154C568.287 115.888 568.062 117.097 567.739 118.782L567.163 121.737L572.353 121.147L571.142 118.395C570.747 117.558 570.347 116.675 569.942 115.746C569.534 114.794 569.155 113.886 568.803 113.021Z",
    fill: "#184A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.086 121.339L596.641 126.324L582.893 127.887L580.492 106.33L585.82 105.724L587.665 122.296L596.086 121.339Z",
    fill: "#184A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.03 119.413L613.585 124.398L598.736 126.086L596.336 104.529L610.875 102.876L611.411 107.689L602.199 108.737L602.597 112.312L610.537 111.41L611.035 115.879L603.095 116.782L603.509 120.495L613.03 119.413Z",
    fill: "#184A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.374 115.138L618.894 114.603C617.107 114.388 615.845 113.893 615.109 113.118C614.396 112.34 613.951 111.161 613.775 109.579C613.497 107.081 613.946 105.173 615.122 103.856C616.318 102.513 618.303 101.684 621.076 101.368C622.221 101.238 623.246 101.168 624.15 101.158C625.054 101.148 625.897 101.215 626.678 101.358L627.21 106.137C625.436 106.037 624.214 106.002 623.544 106.032C622.897 106.059 622.219 106.113 621.508 106.193C620.546 106.303 619.865 106.543 619.465 106.913C619.066 107.284 618.908 107.847 618.992 108.603C619.033 108.97 619.134 109.249 619.294 109.439C619.452 109.607 619.731 109.715 620.131 109.762L624.362 110.256C625.585 110.395 626.474 110.573 627.032 110.788C627.587 110.98 628.048 111.264 628.415 111.64C628.83 112.034 629.156 112.566 629.393 113.235C629.653 113.902 629.838 114.728 629.947 115.714C630.226 118.212 629.763 120.098 628.559 121.373C627.352 122.624 625.351 123.408 622.556 123.726C621.135 123.888 619.773 123.95 618.469 123.912C617.168 123.898 616.148 123.805 615.41 123.633L614.847 118.579C615.797 118.773 616.912 118.89 618.193 118.93C619.471 118.947 620.74 118.884 622.001 118.741C623.009 118.626 623.694 118.421 624.055 118.124C624.417 117.828 624.555 117.302 624.471 116.545C624.417 116.064 624.31 115.728 624.15 115.537C624.01 115.321 623.751 115.188 623.374 115.138Z",
    fill: "#184A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.443 78.9539C420.837 82.4951 419.977 85.3956 417.862 87.6554C416.743 88.8618 415.473 89.8069 414.053 90.4907C412.663 91.1361 411.456 91.5518 410.432 91.7378C409.443 91.9199 407.883 92.132 405.752 92.3743L393.636 93.7516L389.387 55.589L401.142 54.2526C403.135 54.026 404.671 53.9037 405.748 53.8857C406.855 53.8294 408.181 54.0095 409.724 54.426C411.267 54.8424 412.617 55.5593 413.775 56.5767C415.471 58.055 416.46 60.0663 416.744 62.6105C416.924 64.2264 416.695 65.7669 416.057 67.232C415.451 68.6588 414.486 69.8477 413.165 70.7987C417.519 71.7659 419.945 74.4844 420.443 78.9539ZM407.572 65.1153C407.358 63.19 405.979 62.3719 403.436 62.6611L399.672 63.0889L400.332 69.0196L404.044 68.5976C406.622 68.3046 407.798 67.1438 407.572 65.1153ZM411.042 79.3958C410.797 77.1955 409.162 76.2672 406.138 76.6111L401.24 77.1679L402.015 84.13L406.861 83.579C409.92 83.2313 411.314 81.8369 411.042 79.3958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.208 87.548L427.018 89.9568L422.768 51.7942L443.959 49.3853L444.912 57.9461L433.054 59.2941L433.714 65.2248L445.211 63.9178L446.165 72.4786L434.667 73.7856L435.396 80.3352L447.255 78.9871L448.208 87.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.429 83.203L477.973 84.1643L460.85 62.61L460.753 62.6733L463.589 85.7995L454.257 86.8603L450.007 48.6976L458.411 47.7423L475.827 70.0466L475.919 69.9318L472.848 46.1012L482.18 45.0404L486.429 83.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.569 80.0041L493.378 82.413L489.129 44.2503L510.319 41.8415L511.272 50.4023L499.414 51.7503L500.075 57.681L511.572 56.374L512.525 64.9348L501.028 66.2418L501.757 72.7914L513.615 71.4433L514.569 80.0041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.151 47.3468L526.653 48.6538L527.377 55.1518L538.462 53.8917L539.415 62.4525L528.33 63.7126L529.949 78.2557L520.617 79.3165L516.368 41.1538L537.197 38.786L538.151 47.3468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.443 75.2439L546.698 76.3517L542.449 38.189L552.194 37.0812L556.443 75.2439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.617 55.8699C599.018 60.4988 597.085 64.3917 593.817 67.5485C590.583 70.7014 586.645 72.5417 582.005 73.0691C576.437 73.7021 571.481 72.3332 567.138 68.9624C562.791 65.5572 560.307 61.0697 559.687 55.5C559.067 49.9303 560.488 45.0338 563.951 40.8104C567.41 36.5526 571.924 34.1072 577.492 33.4742C580.964 33.0795 584.246 33.4897 587.34 34.7047C590.434 35.9197 593.087 37.8638 595.299 40.5369C596.904 42.4434 597.995 44.4258 598.572 46.4839L588.363 47.6444C587.385 45.7363 586.004 44.2743 584.22 43.2586C582.433 42.2084 580.49 41.8025 578.394 42.0409C575.403 42.3808 573.068 43.7604 571.388 46.1795C569.739 48.5604 569.085 51.2808 569.426 54.3407C569.766 57.4006 571.008 59.9577 573.151 62.0119C575.325 64.0279 577.924 64.8639 580.949 64.52C583.011 64.2856 584.768 63.494 586.219 62.1454C587.67 60.7967 588.733 59.0917 589.408 57.0304L599.617 55.8699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.006 68.4728L606.262 69.5806L602.012 31.4179L611.757 30.3101L616.006 68.4728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.42 44.2147C660.044 49.8188 658.609 54.7517 655.115 59.0134C651.618 63.2407 647.051 65.6748 641.414 66.3156C635.949 66.9369 631.033 65.6156 626.667 62.3519C622.297 59.0537 619.81 54.6885 619.205 49.2564C618.883 46.3684 619.079 43.5956 619.793 40.9381C620.155 39.5043 620.821 37.9837 621.791 36.3764C625.196 30.6973 630.284 27.4728 637.055 26.7031C642.658 26.0662 647.631 27.4331 651.974 30.804C656.318 34.1748 658.799 38.6451 659.42 44.2147ZM649.681 45.3741C649.34 42.3142 648.066 39.7782 645.858 37.7662C643.684 35.7502 641.085 34.9142 638.06 35.258C635.001 35.6058 632.615 36.9912 630.9 39.4143C629.217 41.7991 628.545 44.5215 628.886 47.5813C629.234 50.71 630.512 53.2803 632.721 55.2924C634.925 57.27 637.574 58.083 640.667 57.7314C643.657 57.3914 645.992 56.0118 647.672 53.5927C649.348 51.1391 650.018 48.3996 649.681 45.3741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.461 48.8851C690.89 52.7358 689.978 55.7988 687.725 58.0742C685.503 60.3114 682.416 61.6546 678.463 62.104C674.441 62.5611 671.027 61.9048 668.219 60.135C665.408 58.3308 663.784 55.469 663.347 51.5496L663.21 50.3119L672.902 49.21C673.059 50.6196 673.522 51.803 674.29 52.7602C675.092 53.7135 676.146 54.1159 677.452 53.9674C678.484 53.8502 679.322 53.4068 679.967 52.6371C680.608 51.833 680.872 50.9153 680.757 49.8839C680.692 49.2994 680.531 48.7954 680.275 48.3719C680.019 47.9484 679.631 47.5921 679.112 47.303C678.592 47.0139 678.17 46.8181 677.846 46.7158C677.517 46.5791 676.975 46.397 676.219 46.1696C675.424 45.9118 674.236 45.5594 672.655 45.1125C669.599 44.2413 667.155 43.0743 665.321 41.6116C663.484 40.1145 662.412 37.9907 662.106 35.2402C661.73 31.8709 662.786 29.0005 665.271 26.6289C667.757 24.2574 670.736 22.8743 674.207 22.4797C676.167 22.257 678.116 22.4183 680.057 22.9637C682.027 23.4708 683.676 24.3627 685.001 25.6395C686.056 26.6685 686.818 27.7308 687.288 28.8263C687.758 29.9218 688.117 31.2736 688.366 32.8817L678.725 33.9777C678.419 32.7939 677.974 31.9219 677.389 31.3616C676.801 30.767 675.94 30.5342 674.805 30.6631C673.912 30.7647 673.154 31.1468 672.531 31.8094C671.939 32.4338 671.691 33.1757 671.787 34.0352C671.864 34.7228 672.043 35.242 672.326 35.5929C672.528 35.8484 672.872 36.1226 673.357 36.4157C673.842 36.7087 674.448 36.988 675.174 37.2537C675.899 37.5193 676.516 37.7451 677.024 37.9311C677.567 38.1132 678.218 38.3351 678.978 38.5968C679.769 38.8203 680.217 38.9433 680.324 38.966C683.395 39.9747 685.777 41.2011 687.469 42.6451C689.158 44.0546 690.155 46.1347 690.461 48.8851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0275 -0.026 0 709 124.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.53,
    fill: "url(#paint1_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.53,
    transform: "scale(1 -1)",
    fill: "url(#paint1_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.53,
    transform: "scale(-1 1)",
    fill: "url(#paint1_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.53,
    transform: "scale(-1)",
    fill: "url(#paint1_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M683 124.812C691.678 123.992 708.896 117.463 709.443 97.9586C709.441 97.6294 709.446 97.3096 709.456 97C709.456 97.323 709.452 97.6425 709.443 97.9586C709.481 106.886 713.922 122.652 731.3 124.611C732.64 124.571 733.892 124.65 735 124.812C733.706 124.812 732.473 124.743 731.3 124.611C722.548 124.873 710.047 130.216 709.476 150.539C709.484 151.047 709.477 151.536 709.456 152C709.456 151.505 709.463 151.018 709.476 150.539C709.332 141.127 704.003 124.812 683 124.812Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.75294119119644165,\"g\":0.75294119119644165,\"b\":0.75294119119644165,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":3.1840817637818772e-15,\"m01\":-52.0,\"m02\":735.0,\"m10\":55.0,\"m11\":3.3677788578441014e-15,\"m12\":97.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0275 -0.026 0 340 114.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.53,
    fill: "url(#paint2_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.53,
    transform: "scale(1 -1)",
    fill: "url(#paint2_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.53,
    transform: "scale(-1 1)",
    fill: "url(#paint2_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.53,
    transform: "scale(-1)",
    fill: "url(#paint2_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M314 114.812C322.678 113.992 339.896 107.463 340.443 87.9586C340.441 87.6294 340.446 87.3096 340.456 87C340.456 87.323 340.452 87.6425 340.443 87.9586C340.481 96.8855 344.922 112.652 362.3 114.611C363.64 114.571 364.892 114.65 366 114.812C364.706 114.812 363.473 114.743 362.3 114.611C353.548 114.873 341.047 120.216 340.476 140.539C340.484 141.047 340.477 141.536 340.456 142C340.456 141.505 340.463 141.018 340.476 140.539C340.332 131.127 335.003 114.812 314 114.812Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.75294119119644165,\"g\":0.75294119119644165,\"b\":0.75294119119644165,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":3.1840817637818772e-15,\"m01\":-52.0,\"m02\":366.0,\"m10\":55.0,\"m11\":3.3677788578441014e-15,\"m12\":87.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint3_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0315 -0.0295 0 629.5 184.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1017.77,
    height: 1018.98,
    fill: "url(#paint3_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1017.77,
    height: 1018.98,
    transform: "scale(1 -1)",
    fill: "url(#paint3_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1017.77,
    height: 1018.98,
    transform: "scale(-1 1)",
    fill: "url(#paint3_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1017.77,
    height: 1018.98,
    transform: "scale(-1)",
    fill: "url(#paint3_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M600 184.858C609.846 183.919 629.382 176.44 630.002 154.098C630.001 153.721 630.006 153.355 630.018 153C630.018 153.37 630.012 153.736 630.002 154.098C630.045 164.323 635.084 182.383 654.802 184.627C656.322 184.581 657.743 184.672 659 184.858C657.532 184.858 656.133 184.779 654.802 184.627C644.872 184.927 630.688 191.048 630.041 214.326C630.049 214.909 630.041 215.468 630.018 216C630.018 215.432 630.025 214.875 630.041 214.326C629.876 203.546 623.831 184.858 600 184.858Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.75294119119644165,\"g\":0.75294119119644165,\"b\":0.75294119119644165,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":3.6127081754215758e-15,\"m01\":-59.0,\"m02\":659.0,\"m10\":63.0,\"m11\":3.8576374929990501e-15,\"m12\":153.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint4_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0315 -0.03 0 432 9.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1017.77,
    height: 1018.66,
    fill: "url(#paint4_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1017.77,
    height: 1018.66,
    transform: "scale(1 -1)",
    fill: "url(#paint4_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1017.77,
    height: 1018.66,
    transform: "scale(-1 1)",
    fill: "url(#paint4_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1017.77,
    height: 1018.66,
    transform: "scale(-1)",
    fill: "url(#paint4_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M402 9.85795C412.013 8.91863 431.88 1.43961 432.511 -20.9019C432.509 -21.279 432.515 -21.6454 432.526 -22C432.526 -21.6301 432.521 -21.2641 432.511 -20.9019C432.555 -10.6766 437.679 7.38305 457.73 9.62701C459.277 9.58108 460.722 9.67163 462 9.85795C460.507 9.85795 459.085 9.77854 457.73 9.62701C447.632 9.92692 433.208 16.0476 432.55 39.3263C432.559 39.9087 432.55 40.468 432.526 41C432.526 40.4325 432.534 39.8746 432.55 39.3263C432.383 28.5457 426.235 9.85795 402 9.85795Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":3.6739406106950628e-15,\"m01\":-60.0,\"m02\":462.0,\"m10\":63.0,\"m11\":3.8576374929990501e-15,\"m12\":-22.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint5_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.022 -0.0195 0 397.5 126)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1025.45,
    height: 1028.71,
    fill: "url(#paint5_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1025.45,
    height: 1028.71,
    transform: "scale(1 -1)",
    fill: "url(#paint5_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1025.45,
    height: 1028.71,
    transform: "scale(-1 1)",
    fill: "url(#paint5_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1025.45,
    height: 1028.71,
    transform: "scale(-1)",
    fill: "url(#paint5_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M378 126.25C384.509 125.594 397.422 120.371 397.832 104.767C397.831 104.504 397.834 104.248 397.842 104C397.842 104.258 397.839 104.514 397.832 104.767C397.86 111.908 401.191 124.521 414.225 126.089C415.23 126.057 416.169 126.12 417 126.25C416.029 126.25 415.105 126.195 414.225 126.089C407.661 126.298 398.285 130.573 397.857 146.831C397.863 147.238 397.858 147.628 397.842 148C397.842 147.604 397.847 147.214 397.857 146.831C397.749 139.302 393.753 126.25 378 126.25Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":2.3880613757759671e-15,\"m01\":-39.0,\"m02\":417.0,\"m10\":44.0,\"m11\":2.6942231286269285e-15,\"m12\":104.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint6_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0165 -0.015 0 488 180.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1033.93,
    height: 1037.32,
    fill: "url(#paint6_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1033.93,
    height: 1037.32,
    transform: "scale(1 -1)",
    fill: "url(#paint6_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1033.93,
    height: 1037.32,
    transform: "scale(-1 1)",
    fill: "url(#paint6_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1033.93,
    height: 1037.32,
    transform: "scale(-1)",
    fill: "url(#paint6_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M473 180.687C478.007 180.195 487.94 176.278 488.255 164.575C488.255 164.378 488.257 164.186 488.263 164C488.263 164.194 488.261 164.386 488.255 164.575C488.277 169.931 490.84 179.391 500.865 180.567C501.638 180.542 502.361 180.59 503 180.687C502.253 180.687 501.542 180.646 500.865 180.567C495.816 180.724 488.604 183.93 488.275 196.123C488.279 196.428 488.275 196.721 488.263 197C488.263 196.703 488.267 196.411 488.275 196.123C488.191 190.476 485.117 180.687 473 180.687Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.75294119119644165,\"g\":0.75294119119644165,\"b\":0.75294119119644165,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":1.8369703053475314e-15,\"m01\":-30.0,\"m02\":503.0,\"m10\":33.0,\"m11\":2.0206673994097556e-15,\"m12\":164.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint7_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0175 -0.016 0 672 156.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1031.99,
    height: 1034.99,
    fill: "url(#paint7_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1031.99,
    height: 1034.99,
    transform: "scale(1 -1)",
    fill: "url(#paint7_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1031.99,
    height: 1034.99,
    transform: "scale(-1 1)",
    fill: "url(#paint7_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1031.99,
    height: 1034.99,
    transform: "scale(-1)",
    fill: "url(#paint7_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M656 156.699C661.34 156.177 671.936 152.022 672.272 139.61C672.272 139.401 672.274 139.197 672.281 139C672.281 139.206 672.278 139.409 672.272 139.61C672.296 145.291 675.029 155.324 685.723 156.571C686.548 156.545 687.318 156.595 688 156.699C687.204 156.699 686.445 156.655 685.723 156.571C680.337 156.737 672.644 160.138 672.293 173.07C672.298 173.394 672.293 173.704 672.281 174C672.281 173.685 672.285 173.375 672.293 173.07C672.204 167.081 668.925 156.699 656 156.699Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":1.9594349641362686e-15,\"m01\":-32.0,\"m02\":688.0,\"m10\":35.0,\"m11\":2.1431320581984927e-15,\"m12\":139.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint8_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0275 -0.0255 0 352.5 47.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.96,
    fill: "url(#paint8_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.96,
    transform: "scale(1 -1)",
    fill: "url(#paint8_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.96,
    transform: "scale(-1 1)",
    fill: "url(#paint8_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1020.36,
    height: 1021.96,
    transform: "scale(-1)",
    fill: "url(#paint8_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M327 47.8125C335.511 46.9925 352.398 40.4632 352.934 20.9586C352.933 20.6294 352.937 20.3096 352.947 20C352.947 20.323 352.943 20.6425 352.934 20.9586C352.971 29.8855 357.327 45.6519 374.371 47.6109C375.685 47.5708 376.913 47.6498 378 47.8125C376.731 47.8125 375.522 47.7432 374.371 47.6109C365.787 47.8727 353.527 53.2162 352.967 73.5388C352.975 74.0472 352.968 74.5355 352.947 75C352.947 74.5045 352.954 74.0175 352.967 73.5388C352.825 64.1272 347.599 47.8125 327 47.8125Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":3.1228495402666270e-15,\"m01\":-51.0,\"m02\":378.0,\"m10\":55.0,\"m11\":3.3677788578441014e-15,\"m12\":20.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint9_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0112878 -0.0105143 0 658.514 16.2878)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1049.6,
    height: 1053.25,
    fill: "url(#paint9_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1049.6,
    height: 1053.25,
    transform: "scale(1 -1)",
    fill: "url(#paint9_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1049.6,
    height: 1053.25,
    transform: "scale(-1 1)",
    fill: "url(#paint9_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1049.6,
    height: 1053.25,
    transform: "scale(-1)",
    fill: "url(#paint9_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M648 16.4161C651.509 16.0795 658.472 13.3994 658.693 5.39346C658.693 5.25835 658.695 5.12705 658.699 5C658.699 5.13256 658.697 5.26371 658.693 5.39346C658.709 9.05765 660.505 15.5292 667.532 16.3333C668.074 16.3169 668.581 16.3493 669.029 16.4161C668.505 16.4161 668.007 16.3876 667.532 16.3333C663.993 16.4408 658.938 18.6341 658.707 26.9759C658.71 27.1846 658.707 27.385 658.699 27.5757C658.699 27.3723 658.702 27.1724 658.707 26.9759C658.648 23.1127 656.494 16.4161 648 16.4161Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":1.2876323813616752e-15,\"m01\":-21.028631210327148,\"m02\":669.02862548828125,\"m10\":22.575658798217773,\"m11\":1.3823605227760967e-15,\"m12\":5.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint10_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0132798 -0.0124857 0 475.257 205.053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1042.16,
    height: 1044.84,
    fill: "url(#paint10_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1042.16,
    height: 1044.84,
    transform: "scale(1 -1)",
    fill: "url(#paint10_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1042.16,
    height: 1044.84,
    transform: "scale(-1 1)",
    fill: "url(#paint10_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1042.16,
    height: 1044.84,
    transform: "scale(-1)",
    fill: "url(#paint10_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M462.771 205.203C466.939 204.807 475.207 201.654 475.47 192.236C475.469 192.077 475.471 191.922 475.476 191.773C475.476 191.929 475.474 192.083 475.47 192.236C475.488 196.546 477.621 204.16 485.966 205.106C486.61 205.087 487.211 205.125 487.743 205.203C487.121 205.203 486.53 205.17 485.966 205.106C481.763 205.232 475.76 207.813 475.486 217.627C475.49 217.872 475.486 218.108 475.476 218.332C475.476 218.093 475.48 217.858 475.486 217.627C475.417 213.082 472.858 205.203 462.771 205.203Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.66274511814117432,\"g\":0.67450982332229614,\"b\":0.71372550725936890,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.66274511814117432,\"g\":0.67450982332229614,\"b\":0.71372550725936890,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":1.5290633469878709e-15,\"m01\":-24.971498489379883,\"m02\":487.74298095703125,\"m10\":26.559598922729492,\"m11\":1.6263064351018089e-15,\"m12\":191.7727050781250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint11_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.026 -0.024 0 381 179)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1021.53,
    height: 1023.33,
    fill: "url(#paint11_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1021.53,
    height: 1023.33,
    transform: "scale(1 -1)",
    fill: "url(#paint11_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1021.53,
    height: 1023.33,
    transform: "scale(-1 1)",
    fill: "url(#paint11_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1021.53,
    height: 1023.33,
    transform: "scale(-1)",
    fill: "url(#paint11_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M357 179.295C365.011 178.52 380.904 172.347 381.409 153.906C381.407 153.595 381.412 153.293 381.421 153C381.421 153.305 381.417 153.607 381.409 153.906C381.444 162.346 385.543 177.253 401.584 179.105C402.821 179.067 403.977 179.142 405 179.295C403.805 179.295 402.668 179.23 401.584 179.105C393.506 179.352 381.967 184.404 381.44 203.618C381.447 204.099 381.44 204.561 381.421 205C381.421 204.532 381.427 204.071 381.44 203.618C381.306 194.72 376.388 179.295 357 179.295Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":2.9391524462044029e-15,\"m01\":-48.0,\"m02\":405.0,\"m10\":52.0,\"m11\":3.1840817637818772e-15,\"m12\":153.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint12_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0255 -0.0235 0 714.5 68.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1021.96,
    height: 1023.82,
    fill: "url(#paint12_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1021.96,
    height: 1023.82,
    transform: "scale(1 -1)",
    fill: "url(#paint12_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1021.96,
    height: 1023.82,
    transform: "scale(-1 1)",
    fill: "url(#paint12_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1021.96,
    height: 1023.82,
    transform: "scale(-1)",
    fill: "url(#paint12_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M691 68.7898C698.844 68.0294 714.406 61.9749 714.9 43.8889C714.899 43.5836 714.903 43.287 714.912 43C714.912 43.2995 714.908 43.5958 714.9 43.8889C714.934 52.1666 718.949 66.7863 734.656 68.6028C735.867 68.5656 736.999 68.6389 738 68.7898C736.83 68.7898 735.716 68.7255 734.656 68.6028C726.745 68.8456 715.446 73.8004 714.931 92.6451C714.938 93.1165 714.931 93.5693 714.912 94C714.912 93.5406 714.918 93.089 714.931 92.6451C714.8 83.9179 709.984 68.7898 691 68.7898Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":2.8779200109309159e-15,\"m01\":-47.0,\"m02\":738.0,\"m10\":51.0,\"m11\":3.1228495402666270e-15,\"m12\":43.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint13_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0185917 -0.0177429 0 605.743 9.59172)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1030.11,
    height: 1031.55,
    fill: "url(#paint13_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1030.11,
    height: 1031.55,
    transform: "scale(1 -1)",
    fill: "url(#paint13_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1030.11,
    height: 1031.55,
    transform: "scale(-1 1)",
    fill: "url(#paint13_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1030.11,
    height: 1031.55,
    transform: "scale(-1)",
    fill: "url(#paint13_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M588 9.80299C593.922 9.24859 605.672 4.83436 606.045 -8.35195C606.044 -8.57448 606.047 -8.79074 606.054 -9C606.054 -8.78166 606.051 -8.56565 606.045 -8.35195C606.071 -2.31681 609.102 8.34227 620.961 9.66668C621.875 9.63958 622.73 9.69302 623.486 9.80299C622.603 9.80299 621.762 9.75612 620.961 9.66668C614.988 9.84369 606.458 13.4562 606.068 27.1956C606.073 27.5393 606.068 27.8694 606.054 28.1834C606.054 27.8485 606.059 27.5192 606.068 27.1956C605.969 20.8327 602.333 9.80299 588 9.80299Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":2.1728796435478270e-15,\"m01\":-35.485816955566406,\"m02\":623.485839843750,\"m10\":37.183441162109375,\"m11\":2.2768292209007692e-15,\"m12\":-9.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint14_diamond_1064_21028_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0135 -0.0105 0 526.5 18.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1041.47,
    height: 1053.32,
    fill: "url(#paint14_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1041.47,
    height: 1053.32,
    transform: "scale(1 -1)",
    fill: "url(#paint14_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1041.47,
    height: 1053.32,
    transform: "scale(-1 1)",
    fill: "url(#paint14_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1041.47,
    height: 1053.32,
    transform: "scale(-1)",
    fill: "url(#paint14_diamond_1064_21028)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M516 18.6534C519.505 18.2508 526.458 15.0455 526.679 5.47061C526.678 5.309 526.68 5.15196 526.684 5C526.684 5.15855 526.682 5.31542 526.679 5.47061C526.694 9.85291 528.488 17.5927 535.506 18.5544C536.047 18.5347 536.553 18.5736 537 18.6534C536.477 18.6534 535.98 18.6194 535.506 18.5544C531.971 18.683 526.923 21.3061 526.692 31.2827C526.696 31.5323 526.693 31.772 526.684 32C526.684 31.7568 526.687 31.5177 526.692 31.2827C526.634 26.6624 524.482 18.6534 516 18.6534Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":1.2858792349190956e-15,\"m01\":-21.0,\"m02\":537.0,\"m10\":27.0,\"m11\":1.6532732112853072e-15,\"m12\":5.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683 124.812C691.678 123.992 708.896 117.463 709.443 97.9586C709.441 97.6294 709.446 97.3096 709.456 97C709.456 97.323 709.452 97.6425 709.443 97.9586C709.481 106.886 713.922 122.652 731.3 124.611C732.64 124.571 733.892 124.65 735 124.812C733.706 124.812 732.473 124.743 731.3 124.611C722.548 124.873 710.047 130.216 709.476 150.539C709.484 151.047 709.477 151.536 709.456 152C709.456 151.505 709.463 151.018 709.476 150.539C709.332 141.127 704.003 124.812 683 124.812Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314 114.812C322.678 113.992 339.896 107.463 340.443 87.9586C340.441 87.6294 340.446 87.3096 340.456 87C340.456 87.323 340.452 87.6425 340.443 87.9586C340.481 96.8855 344.922 112.652 362.3 114.611C363.64 114.571 364.892 114.65 366 114.812C364.706 114.812 363.473 114.743 362.3 114.611C353.548 114.873 341.047 120.216 340.476 140.539C340.484 141.047 340.477 141.536 340.456 142C340.456 141.505 340.463 141.018 340.476 140.539C340.332 131.127 335.003 114.812 314 114.812Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint3_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600 184.858C609.846 183.919 629.382 176.44 630.002 154.098C630.001 153.721 630.006 153.355 630.018 153C630.018 153.37 630.012 153.736 630.002 154.098C630.045 164.323 635.084 182.383 654.802 184.627C656.322 184.581 657.743 184.672 659 184.858C657.532 184.858 656.133 184.779 654.802 184.627C644.872 184.927 630.688 191.048 630.041 214.326C630.049 214.909 630.041 215.468 630.018 216C630.018 215.432 630.025 214.875 630.041 214.326C629.876 203.546 623.831 184.858 600 184.858Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint4_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402 9.85795C412.013 8.91863 431.88 1.43961 432.511 -20.9019C432.509 -21.279 432.515 -21.6454 432.526 -22C432.526 -21.6301 432.521 -21.2641 432.511 -20.9019C432.555 -10.6766 437.679 7.38305 457.73 9.62701C459.277 9.58108 460.722 9.67163 462 9.85795C460.507 9.85795 459.085 9.77854 457.73 9.62701C447.632 9.92692 433.208 16.0476 432.55 39.3263C432.559 39.9087 432.55 40.468 432.526 41C432.526 40.4325 432.534 39.8746 432.55 39.3263C432.383 28.5457 426.235 9.85795 402 9.85795Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint5_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378 126.25C384.509 125.594 397.422 120.371 397.832 104.767C397.831 104.504 397.834 104.248 397.842 104C397.842 104.258 397.839 104.514 397.832 104.767C397.86 111.908 401.191 124.521 414.225 126.089C415.23 126.057 416.169 126.12 417 126.25C416.029 126.25 415.105 126.195 414.225 126.089C407.661 126.298 398.285 130.573 397.857 146.831C397.863 147.238 397.858 147.628 397.842 148C397.842 147.604 397.847 147.214 397.857 146.831C397.749 139.302 393.753 126.25 378 126.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint6_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473 180.687C478.007 180.195 487.94 176.278 488.255 164.575C488.255 164.378 488.257 164.186 488.263 164C488.263 164.194 488.261 164.386 488.255 164.575C488.277 169.931 490.84 179.391 500.865 180.567C501.638 180.542 502.361 180.59 503 180.687C502.253 180.687 501.542 180.646 500.865 180.567C495.816 180.724 488.604 183.93 488.275 196.123C488.279 196.428 488.275 196.721 488.263 197C488.263 196.703 488.267 196.411 488.275 196.123C488.191 190.476 485.117 180.687 473 180.687Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint7_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656 156.699C661.34 156.177 671.936 152.022 672.272 139.61C672.272 139.401 672.274 139.197 672.281 139C672.281 139.206 672.278 139.409 672.272 139.61C672.296 145.291 675.029 155.324 685.723 156.571C686.548 156.545 687.318 156.595 688 156.699C687.204 156.699 686.445 156.655 685.723 156.571C680.337 156.737 672.644 160.138 672.293 173.07C672.298 173.394 672.293 173.704 672.281 174C672.281 173.685 672.285 173.375 672.293 173.07C672.204 167.081 668.925 156.699 656 156.699Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint8_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327 47.8125C335.511 46.9925 352.398 40.4632 352.934 20.9586C352.933 20.6294 352.937 20.3096 352.947 20C352.947 20.323 352.943 20.6425 352.934 20.9586C352.971 29.8855 357.327 45.6519 374.371 47.6109C375.685 47.5708 376.913 47.6498 378 47.8125C376.731 47.8125 375.522 47.7432 374.371 47.6109C365.787 47.8727 353.527 53.2162 352.967 73.5388C352.975 74.0472 352.968 74.5355 352.947 75C352.947 74.5045 352.954 74.0175 352.967 73.5388C352.825 64.1272 347.599 47.8125 327 47.8125Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint9_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M648 16.4161C651.509 16.0795 658.472 13.3994 658.693 5.39346C658.693 5.25835 658.695 5.12705 658.699 5C658.699 5.13256 658.697 5.26371 658.693 5.39346C658.709 9.05765 660.505 15.5292 667.532 16.3333C668.074 16.3169 668.581 16.3493 669.029 16.4161C668.505 16.4161 668.007 16.3876 667.532 16.3333C663.993 16.4408 658.938 18.6341 658.707 26.9759C658.71 27.1846 658.707 27.385 658.699 27.5757C658.699 27.3723 658.702 27.1724 658.707 26.9759C658.648 23.1127 656.494 16.4161 648 16.4161Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint10_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.771 205.203C466.939 204.807 475.207 201.654 475.47 192.236C475.469 192.077 475.471 191.922 475.476 191.773C475.476 191.929 475.474 192.083 475.47 192.236C475.488 196.546 477.621 204.16 485.966 205.106C486.61 205.087 487.211 205.125 487.743 205.203C487.121 205.203 486.53 205.17 485.966 205.106C481.763 205.232 475.76 207.813 475.486 217.627C475.49 217.872 475.486 218.108 475.476 218.332C475.476 218.093 475.48 217.858 475.486 217.627C475.417 213.082 472.858 205.203 462.771 205.203Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint11_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357 179.295C365.011 178.52 380.904 172.347 381.409 153.906C381.407 153.595 381.412 153.293 381.421 153C381.421 153.305 381.417 153.607 381.409 153.906C381.444 162.346 385.543 177.253 401.584 179.105C402.821 179.067 403.977 179.142 405 179.295C403.805 179.295 402.668 179.23 401.584 179.105C393.506 179.352 381.967 184.404 381.44 203.618C381.447 204.099 381.44 204.561 381.421 205C381.421 204.532 381.427 204.071 381.44 203.618C381.306 194.72 376.388 179.295 357 179.295Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint12_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691 68.7898C698.844 68.0294 714.406 61.9749 714.9 43.8889C714.899 43.5836 714.903 43.287 714.912 43C714.912 43.2995 714.908 43.5958 714.9 43.8889C714.934 52.1666 718.949 66.7863 734.656 68.6028C735.867 68.5656 736.999 68.6389 738 68.7898C736.83 68.7898 735.716 68.7255 734.656 68.6028C726.745 68.8456 715.446 73.8004 714.931 92.6451C714.938 93.1165 714.931 93.5693 714.912 94C714.912 93.5406 714.918 93.089 714.931 92.6451C714.8 83.9179 709.984 68.7898 691 68.7898Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint13_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588 9.80299C593.922 9.24859 605.672 4.83436 606.045 -8.35195C606.044 -8.57448 606.047 -8.79074 606.054 -9C606.054 -8.78166 606.051 -8.56565 606.045 -8.35195C606.071 -2.31681 609.102 8.34227 620.961 9.66668C621.875 9.63958 622.73 9.69302 623.486 9.80299C622.603 9.80299 621.762 9.75612 620.961 9.66668C614.988 9.84369 606.458 13.4562 606.068 27.1956C606.073 27.5393 606.068 27.8694 606.054 28.1834C606.054 27.8485 606.059 27.5192 606.068 27.1956C605.969 20.8327 602.333 9.80299 588 9.80299Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint14_diamond_1064_21028_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516 18.6534C519.505 18.2508 526.458 15.0455 526.679 5.47061C526.678 5.309 526.68 5.15196 526.684 5C526.684 5.15855 526.682 5.31542 526.679 5.47061C526.694 9.85291 528.488 17.5927 535.506 18.5544C536.047 18.5347 536.553 18.5736 537 18.6534C536.477 18.6534 535.98 18.6194 535.506 18.5544C531.971 18.683 526.923 21.3061 526.692 31.2827C526.696 31.5323 526.693 31.772 526.684 32C526.684 31.7568 526.687 31.5177 526.692 31.2827C526.634 26.6624 524.482 18.6534 516 18.6534Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1064_21028",
    x1: 0,
    y1: 194,
    x2: 1079,
    y2: 194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184A7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CBDEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9ACB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9ACB6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_diamond_1064_21028",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1064_21028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1079,
    height: 194,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBenefits);
export default __webpack_public_path__ + "static/media/banner-benefits.bdc37bfed5e8ec535dc07c35d3aaad36.svg";
export { ForwardRef as ReactComponent };